<template>
  <RkEcharts ref="chart" :option="option" :autoResize="true" />
</template>

<script>
export default {
  name: 'ChartSankey',
  props: {
    title: {
      type: String
    },
    data: {},
    intervalTime: {}
  },
  computed: {
    option() {
      return {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          backgroundColor: 'rgb(50,50,50)',
          textStyle: {
            fontSize: 13
          },
          formatter: a => a.data.tip
        },
        series: [
          {
            type: 'sankey',
            left: '30px',
            top: '20px',
            bottom: '20px',
            label: {
              formatter: a => a.data.content
            },
            animation: false,
            color: [
              '#bf99f8',
              '#3fe1da',
              '#6be6c1',
              '#3fcfdc',
              '#626c91',
              '#3fbcde',
              '#a0a7e6',
              '#3fa9e1',
              '#96dee8'
            ],
            data: this.data.nodes,
            links: this.data.calls,
            itemStyle: {
              normal: {
                borderWidth: 0
              }
            },
            lineStyle: {
              normal: {
                color: 'source',
                opacity: 0.12
              }
            }
          }
        ],
        visualMap: this.data.visualMap
      };
    }
  }
};
</script>
